import React from "react";
import "../App.css";
import Aux from "../utils/AuxFunctions";
import QueryString from "query-string"
import Colors from "../utils/Colors";
import { PayPalButtons } from "@paypal/react-paypal-js";

class Paypal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            amount:0,
        }
    }

    componentDidMount = async () => {
        try {
            const urlParams = QueryString.parse(this.props.location.search);
            if (urlParams.amount) {
                this.setState({amount: urlParams.amount })
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }
    
    createOrder = (data, actions) => {
        if(this.state.amount <= 0)
            return null; 
        try {
            return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: this.state.amount,
                    },
                  },
                ],
              });
        } catch (error) {
            Aux.handleError(error)
        }
        
    }

    onApprove = async(data, actions) => {
        let order = await actions.order.capture();
        console.log(order);
        if(order.status === "COMPLETED"){
            console.log("COMPLETED!")
        }
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(order));
        return order;
    }

    onError = (error) =>{
        Aux.handleError(error)
        let errObj = {
            error: error,
            status: "FAILED",
          };
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(errObj));
    }

    render() { 
        return ( 
            <div style={{ margin:"auto", width:"50%", marginTop:150}}>
                {this.state.amount > 0 ?
                    <div>
                        <div style={{ display: "flex", marginBottom: 20, justifyContent:"center", alignItems:"flex-end" }}>
                            <span style={{ color: Colors.middleText }}>Price: </span>
                            <span style={{ color: Colors.mainColor, marginLeft: 5, fontWeight: "bold", fontSize:20 }}> {this.state.amount || 0}.00$</span>
                        </div>
                        <div style={{marginBottom:5}}>
                            <span style={{ color: Colors.softText, marginLeft: 5, fontWeight: "bold", fontSize:14 }}>Click below to continue</span>
                        </div>
                        <PayPalButtons  
                            style={{ layout: "horizontal" }}
                            createOrder={(data, actions) => this.createOrder(data, actions)}
                            onApprove={(data, actions) => this.onApprove(data, actions)}
                            onCancel={() =>Aux.handleError("Canceled")}
                            onError={(err) => this.onError(err)}
                        ></PayPalButtons> 
                    </div> 
                    : 
                    <div style={{display:"flex", justifyContent:"center"}}>
                        <span>Select an amount first to continue.</span>
                    </div>}
            </div>
        );
    }
}
 
export default Paypal;
